import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

import { useAuth } from './context/AuthContext'
import { AppLayout } from './components/AppLayout'
import { LoginPage } from './pages/LoginPage'
import { AuthCallbackPage } from './pages/AuthCallbackPage'
import { StandingsPage } from './pages/StandingsPage'
import { RatingsPage } from './pages/RatingsPage'
import { MatchupsPage } from './pages/MatchupsPage'
import { DatasetsPage } from './pages/DatasetsPage'
import { PreSeasonRatingsAdjustPage } from './pages/admin/PreSeasonRatingsAdjustPage'
import { PreSeasonRatingsAuditPage } from './pages/admin/PreSeasonRatingsAuditPage'
import { GolfBettingPage } from './pages/GolfBettingPage'
import { LoadingScreen } from './components/LoadingScreen'

export function App() {
  return (
    <Routes>
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/login" element={<LoginPage />} />

      <Route element={<RequireAuth />}>
        <Route element={<AppLayout />}>
          <Route index element={<StandingsPage />} />
          <Route path="/standings" element={<Navigate to="/" replace />} />
          <Route path="/matchups" element={<MatchupsPage />} />
          <Route path="/ratings" element={<RatingsPage />} />
          <Route path="/pre-season-ratings" element={<Navigate to="/admin/ps-ratings/adjust" replace />} />
          <Route path="/admin" element={<Navigate to="/admin/ps-ratings/adjust" replace />} />
          <Route path="/admin/ps-ratings/adjust" element={<PreSeasonRatingsAdjustPage />} />
          <Route path="/admin/ps-ratings/audit" element={<PreSeasonRatingsAuditPage />} />
          <Route path="/datasets" element={<DatasetsPage />} />
          <Route path="/pga">
            <Route index element={<Navigate to="/pga/bets" replace />} />
            <Route path="bets" element={<GolfBettingPage />} />
          </Route>
          <Route path="/golf" element={<Navigate to="/pga/bets" replace />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

function RequireAuth() {
  const { status } = useAuth()
  if (status === 'loading') return <LoadingScreen label="Checking session..." />
  if (status === 'unauthenticated') return <Navigate to="/login" replace />
  return <Outlet />
}
